import React from 'react';
import azwad from "../../images/azwad_transparent_bg.png";

function About() {
    return (
        <div id="about">
        <div className='w-10/12 mx-auto py-16 md:py-24' data-aos="fade-up" data-aos-duration="2000">

            {/* Section Title */}
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                About <span className="text-indigo-600">Me</span>
            </h2>

            <div className='flex flex-col-reverse md:flex-row-reverse items-center md:items-start gap-10 md:gap-16'>

                {/* Text Content */}
                <div className="w-full md:flex-1">
                    <p className="text-sm md:text-base text-justify leading-relaxed mb-4 text-gray-800">
                        A Backend Engineer currently working as <span className="font-semibold text-blue-600">Senior Software Engineer I at Brain Station 23 PLC</span>.
                        I hold a BSc. in Computer Science and Software Engineering from{" "}
                        <span className="font-semibold text-gray-900">American International University-Bangladesh (AIUB)</span> with
                        a CGPA of <span className="font-semibold text-indigo-600">3.83 / 4.00</span>, earning 5 consecutive Dean's List awards.
                    </p>
                    <p className="text-sm md:text-base text-justify leading-relaxed mb-6 text-gray-800">
                        I specialize in architecting scalable, high-performance backend systems using{" "}
                        <span className="font-semibold text-gray-900">Python, Go, Django, Odoo ERP, and REST APIs</span>.
                        I've led ERP development projects, built real-time systems with WebSockets &amp; Django Channels,
                        and designed background task pipelines using Celery and RabbitMQ. Prior to my current role,
                        I worked as a <span className="font-semibold text-gray-900">Remote Freelance Backend Developer</span> on Fiverr,
                        independently delivering web applications for international clients across multiple time zones —
                        comfortable with async communication and distributed team workflows.
                    </p>

                    {/* Stats */}
                    <div className="grid grid-cols-3 gap-4 text-center mb-6">
                        <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-4">
                            <p className="text-2xl font-bold text-indigo-600">3.5+</p>
                            <p className="text-xs font-semibold text-gray-500 mt-1">Years Experience</p>
                        </div>
                        <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-4">
                            <p className="text-2xl font-bold text-indigo-600">3.83</p>
                            <p className="text-xs font-semibold text-gray-500 mt-1">CGPA / 4.00</p>
                        </div>
                        <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-4">
                            <p className="text-2xl font-bold text-indigo-600">5×</p>
                            <p className="text-xs font-semibold text-gray-500 mt-1">Dean's List</p>
                        </div>
                    </div>

                    {/* Quote */}
                    <div className="border-l-4 border-indigo-500 pl-4 mt-2">
                        <p className="text-base md:text-lg font-semibold text-gray-800 italic">
                            "Think Big, Gain Bigger !"
                        </p>
                    </div>
                </div>

                {/* Image */}
                <div className="flex-shrink-0">
                    <img
                        className='w-48 md:w-80 object-contain'
                        alt="Afid Md Azwad"
                        src={azwad}
                    />
                </div>

            </div>
        </div>
        </div>
    );
}

export default About;
